import * as React from 'react';
import { InboxNotificationDetailsResponse } from 'src/entities/Notifications';

/**
 * This hook is used to get the total read and unread notifications count.
 * @param notifications - all loaded notifications
 * @returns the total read and unread notifications count
 **/
export const useNotificationsCounts = (
  notifications: Array<InboxNotificationDetailsResponse>,
) => {
  // get total read and unread notifications count
  const { unreadNotificationCount, readNotificationCount } =
    React.useMemo(() => {
      const totalUnreadNotifications = notifications?.reduce((prev, curr) => {
        if (!curr.isRead) return prev + 1;
        return prev;
      }, 0);
      return {
        unreadNotificationCount: totalUnreadNotifications,
        readNotificationCount: notifications.length - totalUnreadNotifications,
      };
    }, [notifications]);

  return { unreadNotificationCount, readNotificationCount };
};
